// extracted by mini-css-extract-plugin
export default {"container":"InstallDismantle_container__tpkPQ","info":"InstallDismantle_info__mgFsf","subTitle":"InstallDismantle_subTitle__qV1cG","textButton":"InstallDismantle_textButton__mM8fV"};